export default __webpack_public_path__ + "static/media/neu.d0de1aeb.svg";